import { IOfferListTableLang } from '../../../types/lang'

export const offerListTableLang: IOfferListTableLang = {
	offer_list_table: {
		column_id: 'ID_ua',
		column_name: 'Name_ua',
		column_affiliate_network: 'Affiliate Network_ua',
		column_country: 'Country_ua',
	}
}